import React, { useEffect, useState } from 'react';

// API/Components
import { ANALYSIS_TYPE } from './enums';
import { BuildDataGridMeasurementCell } from './ui_helpers';
import NoItemsOverlay from '../components/no_items_overlay';

// Material UI
import { DataGrid } from '@mui/x-data-grid';


// Unit Snapshot Report table columns
const columns = [
	{
		field: 'string_num',
		headerName: 'String',
		description: 'String Number',
		minWidth: 60,
		maxWidth: 100,
		flex: 1,
		headerAlign: "left",
	},
	{
		field: 'unit_num',
		headerName: 'Unit',
		description: 'Unit Number',
		minWidth: 60,
		maxWidth: 100,
		flex: 1,
		headerAlign: "left",
	},
	{
		field: 'voltage',
		headerName: 'Voltage',
		description: 'Unit Voltage',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.VOLTAGE),
	},
	{
		field: 'impedance',
		headerName: 'Impedance',
		description: 'Unit Impedance',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.IMPEDANCE),
	},
	{
		field: 'temperature',
		headerName: 'Temp',
		description: 'Unit Temperature',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.TEMPERATURE),
	},
];


export default function UnitSnapshotReport(props) {
	const { snapshotData, selectedString, loading } = props;
	
	const [reportData, setReportData] = useState([]);
	const [isLoading, setIsLoading] = useState(loading);
	const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 40 });
	
	useEffect(() => {
		const formattedData = FormatDataForReport(snapshotData.units, selectedString);
		if (formattedData !== undefined && formattedData !== null) {
			setReportData(formattedData);
		}
	}, [snapshotData, selectedString]);

	useEffect(() => {
		setIsLoading(loading);
	}, [loading]);
	
	function FormatDataForReport(unitData, selectedString) {
		setIsLoading(true);
		let rows = [];
		if (unitData !== null && unitData !== undefined) {
			unitData.forEach(unit => {
				if (selectedString == 0 || unit.string_nbr == selectedString) {
					rows.push({
						string_num: unit.string_nbr,
						unit_num: unit.unit_nbr,
						voltage: {
							measurement: unit.measurement.unit_voltage,
							result: unit.analysis.voltage_analysis_result,
							out: unit.analysis.voltage_analysis_out,
							valid: unit.analysis.voltage_analysis_valid,
						},
						impedance: {
							measurement: unit.measurement.unit_imp,
							result: unit.analysis.impedance_analysis_result,
							out: unit.analysis.impedance_analysis_out,
							valid: unit.analysis.impedance_analysis_valid,
						},
						temperature: {
							measurement: unit.measurement.unit_temp,
							result: unit.analysis.temperature_analysis_result,
							out: unit.analysis.temperature_analysis_out,
							valid: unit.analysis.temperature_analysis_valid,
						},
					});
				}
			});
		}
	
		setIsLoading(false);
		return rows;
	}
	
	return (
		<DataGrid
			getRowId={(row) => `S${row.string_num}U${row.unit_num}`}
			rows={reportData}
			columns={columns}
			loading={isLoading}
			density="compact"
			pagination
			paginationModel={paginationModel}
			onPaginationModelChange={setPaginationModel}
			pageSizeOptions={[30, 40, 60, 80]}  // Max pagination size for DataGrid (Free Edition) is 100
			slots={{
				noRowsOverlay: NoItemsOverlay,
			}}
			slotProps={{
				noRowsOverlay: { noItemsText: 'No Unit Snapshot Data' },
			}}
			sx={{
				padding: 1,
				height: '100%'
			}}
		/>
	);
}